import { forwardRef, memo } from 'react';
import { FormattedMessage } from 'react-intl';
// Material UI imports
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

type JobSkillsResetButtonProps = {
  readonly title?: string;
  readonly onReset?: () => void;
  readonly disabled?: boolean | null;
}

const JobSkillsResetButton = forwardRef<HTMLButtonElement, JobSkillsResetButtonProps>(({
  title,
  onReset,
  disabled
}, ref) => (
  <Box
      p={0.5}
      flexGrow={1}
      display="flex"
      alignItems="flex-end"
      justifyContent="flex-end"
  >
    <Button
        ref={ref}
        color="primary"
        variant="text"
        disabled={disabled || !onReset ? true : undefined}
        onClick={onReset}
    >
      <FormattedMessage id={title || 'hr.button.reset_to_defaul'}/>
    </Button>
  </Box>
));

JobSkillsResetButton.displayName = 'JobSkillsResetButton';

export default memo(JobSkillsResetButton);
